import { useEffect } from 'react';
import { Formik, FormikProps } from 'formik';
import { ProfileAvatarUploader } from 'features/profile';
import ProfileFormTemplate from 'features/profile/components/forms/profile-form/profile-form.template';
import { UpdateUser } from 'features/profile/types/user.types';
import { transformProfileObjectToRegisterFields } from 'features/profile/components/forms/profile-form/utils';
import { useUserProfileQuery } from 'app/store';
import AnimatedLayout from 'components/layouts/animated-layout';
import { SettingsContentHeader } from 'components/layouts/settings-workspace/settings-workspace';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';
import AccountIdentifier from 'features/profile/components/account-identifier';

const ProfileFormTab = (): JSX.Element => {
    const { data: profile } = useUserProfileQuery();

    return (
        <>
            <HelmetTabComponent title="پروفایل" />

            <Formik
                initialValues={transformProfileObjectToRegisterFields(profile)}
                key={profile?.id}
                validateOnChange={false}
                validateOnBlur={true}
                onSubmit={() => {}}
            >
                {FormTemplate}
            </Formik>
        </>
    );
};

const FormTemplate = (props: FormikProps<UpdateUser>) => {
    useEffect(() => {
        // This tab renders the profile read-only: formik-mui fields derive
        // their disabled state from isSubmitting.
        props.setSubmitting(true);
    }, [props.isSubmitting]);

    return (
        <AnimatedLayout>
            <SettingsContentHeader
                title="پروفایل"
                description="مشخصات حساب کاربری شما."
            />

            <ProfileAvatarUploader />
            <AccountIdentifier />
            <ProfileFormTemplate props={{ ...props }} />
        </AnimatedLayout>
    );
};

export default ProfileFormTab;
